export interface InsidePage {
  src: string
  alt: string
}

/** The five real interior pages of the product — do not replace with mockups. */
export const insidePages: InsidePage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/iUmru4RYDjPDz8CzYAR6F2/Captura_de_pantalla_2026-09-29_a_la(s)_9.39.36_p._m..png',
    alt: 'Interior page: Drain system anatomy — follow the water out',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/jMnMW2FrPsusyrr7pNjdoG/Captura_de_pantalla_2026-09-29_a_la(s)_9.39.24_p._m..png',
    alt: 'Interior page: Water level & pressure sensing — how the washer knows when to stop filling',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/tufmUNpoFZ8WvoAyXbLiLS/Captura_de_pantalla_2026-09-29_a_la(s)_9.40.08_p._m..png',
    alt: 'Interior page: Wiring & connector faults — the component may be good, the connection may not be',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/rjmFf5R2WQpRxaBB4RYJWN/Captura_de_pantalla_2026-09-29_a_la(s)_9.39.56_p._m..png',
    alt: 'Interior page: Noise location map — where is the sound coming from?',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/w2zh3nkgeA6AtYa4dDMxqn/Captura_de_pantalla_2026-09-29_a_la(s)_9.39.08_p._m..png',
    alt: 'Interior page: Water inlet system — how water gets into the washer',
  },
]
